import { Pipe, PipeTransform } from '@angular/core';
import { AccessLevel } from 'app/models/permission.model';
import { PermissionService } from 'app/services/permission.service';

/**
 * Does the logged in user have at least the given level on an area.
 *
 * Usage: `@if ('Devices' | can: 'ReadWrite') { ... }` or `[disabled]="!('Staff' | can: 'ReadWrite')"`.
 * The level defaults to Read. Impure, because the permission map can change while the page is open
 * (lookups are cheap).
 */
@Pipe({
  name: 'can',
  standalone: true,
  pure: false
})
export class CanPipe implements PipeTransform {
  constructor(private permissions: PermissionService) { }

  transform(area: string, level: AccessLevel = 'Read'): boolean {
    return this.permissions.has(area, level);
  }
}
